import type {NavbarItemInterface} from "@/components/helpers/Interfaces.ts";

export const routes: NavbarItemInterface[] = [
    {
        cls: ['nav-link'],
        title: 'navbar.home',
        href: '/home'
    },
    {
        title: "navbar.logs",
        href: "#",
        roles: ['Admin', 'Super', 'Operator'],
        subitems: [
            {
                title: 'navbar.delivered',
                href: '/issueLogs/delivered',
                roles: ['Admin', 'Super', 'Operator']
            },
            {
                title: 'navbar.devolution',
                href: '/issueLogs/devolution',
                roles: ['Admin', 'Super', 'Operator']
            },
        ]
    },
    {
        title: 'navbar.configs',
        href: '/products',
        roles: ['Admin', 'Super'],
        subitems: [
            {
                title: 'navbar.products',
                href: '/products',
                roles: ['Admin', 'Super'],
            },
            {
                title: 'navbar.stock',
                href: '/stock',
                roles: ['Admin', 'Super'],
            },
            {
                title: 'navbar.stockCharge',
                href: '/stockCharge',
                roles: ['Admin', 'Super']
            },
            {
                title: 'navbar.stockOut',
                href: '/stockCharge/out-stock',
                roles: ['Admin', 'Super'],
            },
            {
                title: 'navbar.users',
                href: '/users',
                roles: ['Super']
            },

        ]
    }
]
